import React, { useState, useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './Presentation.css';
import Slide2Component from '../components/Slide2';
import Slide3Component from '../components/Slide3';
import Slide4Component from '../components/Slide4';
import Slide5Component from '../components/Slide5';
import Slide6Component from '../components/Slide6';
import Slide7Component from '../components/Slide7';
import Slide8Component from '../components/Slide8';

const Presentation = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slide2Ref = useRef(null);

  const slides = [
    {
      id: 1,
      title: 'MarIAne',
      subtitle: 'Managed Assistant of Research with Intelligence Artificial for Navigation Ethic',
      tagline: 'Le Premier Moteur de Recherche Sémantique avec IA Intégrée',
      content: [
        'Recherche sémantique intelligente',
        'Assistant IA intégré en temps réel',
        'Navigation enrichie par l\'intelligence artificielle',
        'Éthique et respect de la vie privée avant tout'
      ]
    },
    {
      id: 2,
      type: 'custom',
      title: 'Le Moteur de Recherche',
      subtitle: 'Une Nouvelle Approche de la Recherche Web'
    },
    {
      id: 3,
      title: 'Interface Nouvelle Génération',
      subtitle: 'Cards, Résumés & Chat Intégré',
      content: [
        {
          section: 'Navigation par Cards Intelligentes',
          items: [
            'Présentation visuelle enrichie des résultats',
            'Résumés IA instantanés pour chaque résultat',
            'Aperçu du contenu sans quitter la page'
          ]
        },
        {
          section: 'Chat Intégré',
          items: [
            'Affiner votre recherche en dialogue avec l\'IA',
            'Poser des questions de suivi',
            'L\'assistant comprend le contexte de votre navigation'
          ]
        },
        {
          section: 'Summary IA',
          items: [
            'Synthèse intelligente des résultats',
            'Extraction des informations clés',
            'Comparaison automatique des sources'
          ]
        }
      ]
    },
    {
      id: 4,
      title: 'Modèles IA Embarqués',
      subtitle: 'L\'Intelligence au Cœur du Moteur',
      content: [
        {
          section: 'Intégration Native',
          items: [
            'Modèles de langage directement intégrés',
            'Traitement sémantique en temps réel',
            'Pas de dépendance à des services externes'
          ]
        },
        {
          section: 'Fonctionnalités IA',
          items: [
            'Compréhension du langage naturel',
            'Génération de résumés contextuels',
            'Suggestions intelligentes',
            'Réponses conversationnelles',
            'Analyse sémantique du contenu web'
          ]
        },
        {
          section: 'Performance',
          items: [
            'Réponses instantanées',
            'Traitement local pour la confidentialité',
            'Optimisation continue des résultats'
          ]
        }
      ]
    },
    {
      id: 5,
      title: 'Le Navigateur',
      subtitle: 'Technologies Avancées',
      content: [
        {
          section: 'Proxy MITM Intégré',
          items: [
            'Filtrage intelligent du contenu en temps réel',
            'Blocage automatique des trackers et publicités',
            'Anti-fingerprinting avancé',
            'Contrôle total sur les données échangées'
          ]
        },
        {
          section: 'Protection Multi-Niveaux',
          items: [
            '🛡️ Spam & Malware : Détection et blocage automatique',
            '🔒 Fingerprinting : Protection contre le tracking avancé',
            '🚫 Trackers : Élimination des mouchards publicitaires',
            '📋 Headers : Nettoyage des métadonnées sensibles',
            '⚡ Scripts : Contrôle fin de l\'exécution JavaScript'
          ]
        },
        {
          section: 'Transparence',
          items: [
            'Visualisation en temps réel des requêtes bloquées',
            'Statistiques détaillées par site',
            'Contrôle granulaire par domaine'
          ]
        }
      ]
    },
    {
      id: 6,
      title: 'L\'Éthique au Cœur du Projet',
      subtitle: 'Navigation Éthique - Notre Engagement Fondamental',
      highlight: 'L\'ÉTHIQUE D\'ABORD',
      quote: '"L\'éthique n\'est pas une option, c\'est notre fondation."',
      content: [
        {
          section: 'Zero Collecte de Données',
          items: [
            '❌ Aucune donnée utilisateur n\'est capturée',
            '❌ Aucun tracking de vos recherches',
            '❌ Aucune télémétrie vers nos serveurs',
            '✅ Tout reste local, tout reste dans votre navigateur'
          ]
        },
        {
          section: 'Traitement 100% Local',
          items: [
            'Modèles IA exécutés localement sur votre machine',
            'Historique stocké uniquement en local',
            'Aucune synchronisation cloud obligatoire',
            'Vos données vous appartiennent, à 100%'
          ]
        },
        {
          section: 'Transparence Totale',
          items: [
            'Code source ouvert',
            'Règles de filtrage consultables',
            'Aucun algorithme opaque',
            'Vous savez exactement ce qui se passe'
          ]
        },
        {
          section: 'Contrôle Utilisateur',
          items: [
            'Vous décidez ce qui est bloqué ou autorisé',
            'Configuration granulaire par site',
            'Export de vos données à tout moment',
            'Suppression complète quand vous le souhaitez'
          ]
        }
      ]
    },
    {
      id: 7,
      title: 'L\'Équipe',
      subtitle: 'Un Projet Étudiant, Une Ambition Nationale',
      highlight: '4 Étudiants, 4 Universités, 1 Vision',
      quote: '"Pas de capital-risque, pas de compromis éthiques."',
      content: [
        {
          section: 'Notre Force',
          items: [
            '🎓 Collaboration inter-universitaire',
            '🌍 Diversité des compétences et perspectives',
            '💡 Innovation sans compromis commerciaux',
            '🤝 Travail collaboratif distribué'
          ]
        },
        {
          section: 'Notre Mission',
          items: [
            'Prouver qu\'il est possible de créer une technologie de recherche avancée qui respecte vraiment les utilisateurs, sans modèle économique basé sur leurs données.'
          ]
        },
        {
          section: 'Valeurs de l\'Équipe',
          items: [
            'Éthique et transparence avant tout',
            'Innovation au service de l\'utilisateur',
            'Open source et partage des connaissances',
            'Recherche et développement académique'
          ]
        },
        {
          section: 'Un Projet Libre et Ouvert',
          items: [
            'Développé par des étudiants, pour tous',
            'Aucun investisseur à satisfaire',
            'Aucune pression commerciale',
            '100% orienté vers l\'intérêt des utilisateurs'
          ]
        }
      ]
    },
    {
      id: 8,
      title: 'L\'Écosystème MarIAne',
      subtitle: 'Trois Composants Intégrés',
      quote: 'Remettre le contrôle du web entre les mains des utilisateurs',
      content: [
        {
          section: '1. Moteur de Recherche Sémantique',
          items: [
            'Interface de recherche intelligente',
            'Résultats enrichis par IA',
            'Cards et summaries automatiques',
            'Chat contextuel intégré'
          ]
        },
        {
          section: '2. Navigateur Sécurisé',
          items: [
            'Proxy MITM pour protection totale',
            'Technologies anti-tracking',
            'Contrôle du contenu en temps réel',
            'Extensions Chrome compatibles'
          ]
        },
        {
          section: '3. Core IA',
          items: [
            'Modèles de langage embarqués',
            'API WebSocket pour communication temps réel',
            'Architecture modulaire (Tab, Extension, Shield, Session managers)',
            'Séparation UI/Logique pour performance maximale'
          ]
        }
      ]
    }
  ];

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        prevSlide();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentSlide]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const renderSlideContent = (slide) => {
    if (slide.id === 1) {
      return (
        <div className="slide-content title-slide">
          <div className="home-container-slide">
            <div className="logo-container-slide">
              <h1 className="logo-slide">
                MAR<span className="neon-slide">IA</span>NE
              </h1>
              <p className="tagline-slide">Managed Assistant of Research with Intelligence Artificial for Navigation Ethic</p>
            </div>

            <div className="search-form-slide">
              <div className="search-box-slide">
                <input
                  type="text"
                  className="search-input-slide"
                  placeholder="Rechercher sur MarIAne..."
                  disabled
                />
                <button className="search-button-slide">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                  </svg>
                </button>
              </div>
            </div>

            <div className="features-list-slide">
              {slide.content.map((item, idx) => (
                <div key={idx} className="feature-item-slide">
                  <div className="feature-icon-slide">✓</div>
                  <span className="feature-text-slide">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }

    if (slide.id === 2) {
      return <Slide2Component />;
    }

    if (slide.id === 3) {
      return <Slide3Component />;
    }

    if (slide.id === 4) {
      return <Slide4Component />;
    }

    if (slide.id === 5) {
      return <Slide5Component />;
    }

    if (slide.id === 6) {
      return <Slide6Component />;
    }

    if (slide.id === 7) {
      return <Slide7Component />;
    }

    if (slide.id === 8) {
      return <Slide8Component />;
    }

    return (
      <div className="slide-content">
        <h1 className="slide-title">{slide.title}</h1>
        <h2 className="slide-subtitle">{slide.subtitle}</h2>
        {slide.highlight && (
          <div className="slide-highlight">{slide.highlight}</div>
        )}

        <div className="content-sections">
          {slide.content.map((section, idx) => (
            <div key={idx} className="content-section">
              <h3 className="section-title">{section.section}</h3>
              <ul className="section-items">
                {section.items.map((item, itemIdx) => (
                  <li key={itemIdx} className="section-item">
                    <span className="item-bullet">▸</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {slide.quote && (
          <div className="slide-quote">{slide.quote}</div>
        )}
      </div>
    );
  };

  return (
    <div className="presentation-container">
      <div className="slide-wrapper">
        {renderSlideContent(slides[currentSlide])}
      </div>

      <div className="navigation-controls">
        <button
          className="nav-button prev"
          onClick={prevSlide}
          disabled={currentSlide === 0}
        >
          ←
        </button>

        <div className="slide-indicators">
          {slides.map((_, idx) => (
            <button
              key={idx}
              className={`indicator ${idx === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(idx)}
            >
              {idx + 1}
            </button>
          ))}
        </div>

        <button
          className="nav-button next"
          onClick={nextSlide}
          disabled={currentSlide === slides.length - 1}
        >
          →
        </button>
      </div>

      <div className="slide-counter">
        {currentSlide + 1} / {slides.length}
      </div>

      <div className="keyboard-hint">
        Utilisez les flèches ← → ou espace pour naviguer
      </div>
    </div>
  );
};

export default Presentation;
